import React, { useEffect, useMemo, useState } from "react";
import Head from "../../../layout/head/Head";
import Content from "../../../layout/content/Content";

import { StepHeader } from "./StepHeader";
import classnames from "classnames";
import { Button, Col, Form, Nav, NavItem, NavLink, Row, TabContent, TabPane } from "reactstrap";
import { useLocation, useNavigate } from "react-router";
import useLogout from "../../../hooks/useLogout";
import { useFieldArray, useForm } from "react-hook-form";
import { DAYS, slotDuration } from "../../../assets/constants";
import classNames from "classnames";
import MyLoader from "../../../MyComp/UI/form/MyLoader";
import MyMobile from "../../../MyComp/UI/form/MyMobile";
import MySelect from "../../../MyComp/UI/form/MySelect";
import MyInput from "../../../MyComp/UI/form/MyInput";
import {

  deleteClinicAPI,
  doctorOfflineSlot,
  doctorOnlineSlot,
  getDoctorOfflineAPI,
  getDoctorSlotAPI,

} from "../../../api/doctor";
import { getZipDetailsAPI } from "../../../api/master/indes";
import { transformBack } from "../../../utils/Utils";
import { toast } from "react-toastify";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Icon,
  PreviewAltCard,
} from "../../../components/Component";
import MyButton from "../../../MyComp/UI/form/MyButton";

const StepThree = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const logout = useLogout();
  const doctor = location?.state?.data;
  console.log("data", location.state);
  const [activeTab, setActiveTab] = useState("offline");
  const [activeDay, setActiveDay] = useState("monday");
  const [api, setApi] = useState([]);
  const [loading, setLoading] = useState(true);
  const [startTime, setStartTime] = useState("");

  const [mode, setMode] = useState("Add");
  const doctorId = location?.state?.doctorId || null;
  const toggle = (tab) => {
    setActiveTab(tab);
  };
  const defaultSlotStructureTime = {
    start_time: "",
    end_time: "",
  };

  const defaultValuesTime = {
    slots: DAYS.reduce((acc, day) => {
      acc[day] = [{ ...defaultSlotStructureTime }];
      return acc;
    }, {}),
    to_all_time: false,
  };
  const defaultSlotStructureOffline = {
    start_time: "",
    end_time: "",
  };

  // Structure for each clinic
  const defaultClinicStructure = {
    clinic_id: "",
    clinic_name: "",
    fees: "",
    clinic_address: "",
    pin_code: "",
    city: "",
    state: "",
    mobile: "",
    slot_duration: "",
    slots: [{ ...defaultSlotStructureOffline }],
  };

  // Default values with clinics array for each day

  // ========== ONLINE FORM (VIDEO CONSULTATIONS) ==========
  const {
    getValues: getValueTime,
    register: registerTime,
    handleSubmit: handleSubmitTime,
    control: controlTime,
    setValue: setValueTime,
    watch: watchTime,
    trigger: triggerTime,
    formState: { errors: errorsTime },
    reset: resetTime,
  } = useForm({
    defaultValues: defaultValuesTime,
    mode: "onChange",
  });

  const {
    fields: timeFields,
    append: appendTime,
    remove: removeTime,
    replace: replaceTime,
  } = useFieldArray({
    control: controlTime,
    name: `slots.${activeDay}`,
  });

  const defaultValuesOffline = {
    clinics: DAYS.reduce((acc, day) => {
      acc[day] = [{ ...defaultClinicStructure }]; // Array of clinics for each day
      return acc;
    }, {}),
    to_all_offline: false,
  };

  // ========== ONLINE (VIDEO CONSULTATIONS) CONFIG ==========

  const {
    register: registerOffline,
    handleSubmit: handleSubmitOffline,
    control: controlOffline,
    setValue: setValueOffline,
    watch: watchOffline,
    trigger: triggerOffline,
    formState: { errors: errorsOffline },
    reset: resetOffline,
  } = useForm({
    defaultValues: defaultValuesOffline,
    mode: "onChange",
  });

  // Field array for clinics for the active day
  const {
    fields: offlineClinicsFields,
    append: appendOfflineClinic,
    remove: removeOfflineClinic,
    replace: replaceOfflineClinics,
  } = useFieldArray({
    control: controlOffline,
    name: `clinics.${activeDay}`,
  });



  const {
    fields: offlineFields,
    append: appendOffline,
    remove: removeOffline,
    replace: replaceOffline,
  } = useFieldArray({
    control: controlOffline,
    name: `slots.${activeDay}`,
  });


  const buildOfflinePayload = (formData) => {
    const activeDayClinics = formData.clinics?.[activeDay];

    if (!activeDayClinics || activeDayClinics.length === 0) {
      throw new Error("No clinic added");
    }

    // For now you allow ONE clinic only
    const clinic = activeDayClinics[0];

    const availability = DAYS.map((day) => {
      let slots = [];

      if (formData.to_all_offline) {
        slots = clinic.slots || [];
      } else {
        slots = formData.clinics?.[day]?.[0]?.slots || [];
      }

      return {
        day,
        slots: slots
          .filter((s) => s.start_time && s.end_time)
          .map((s) => ({
            start_time: s.start_time,
            end_time: s.end_time,
          })),
      };
    });

    return {
      doctor_id: doctorId,
      clinic_name: clinic.clinic_name,
      clinic_address: clinic.clinic_address,
      clinic_phone: clinic.mobile,
      pincode: clinic.pin_code,
      city: clinic.city,
      state: clinic.state,
      slot_duration: Number(clinic.slot_duration),
      fee: Number(clinic.fees),
      availability,
    };
  };



  const onFormSubmitOffline = (data) => {
    try {
      const payload = buildOfflinePayload(data);



      doctorOfflineSlot(payload)
        .then((res) => {
          toast.success(res.data.message);
          toast.clearWaitingQueue();

          navigate("/doctors", {
            state: { mode: "Add", doctorId: res.data.data?.doctorId },
          });
        })
        .catch((err) => {
          toast.error(err?.response?.data?.message);
        });
    } catch (err) {
      toast.error(err?.response?.data?.message);
    }
  };


  ;
  function cleanObject(obj) {
    if (Array.isArray(obj)) {
      return obj.map(cleanObject).filter((item) => item !== undefined && Object.keys(item).length > 0);
    } else if (obj !== null && typeof obj === "object") {
      const newObj = {};
      for (const [key, value] of Object.entries(obj)) {
        const cleanedValue = cleanObject(value);
        if (
          cleanedValue !== null &&
          cleanedValue !== undefined &&
          cleanedValue !== "" &&
          !(typeof cleanedValue === "object" && Object.keys(cleanedValue).length === 0)
        ) {
          newObj[key] = cleanedValue;
        }
      }
      return Object.keys(newObj).length > 0 ? newObj : undefined;
    }
    return obj;
  }
  function cleanSchedule(schedule) {
    const cleaned = {};
    for (const [day, slots] of Object.entries(schedule)) {
      const cleanedSlots = cleanObject(slots);
      if (Array.isArray(cleanedSlots) && cleanedSlots.length > 0) {
        cleaned[day] = cleanedSlots;
      }
    }
    return cleaned;
  }
  const onFormSubmitTime = (data) => {
    console.log(data, "data");
    const cleanedData = cleanSchedule(data?.slots);

    const isSynced = watchTime("to_all_time");

    let finalSlots = cleanedData;

    if (isSynced === true) {
      const sourceSlots = cleanedData[activeDay] || [];

      finalSlots = DAYS.reduce((acc, day) => {
        acc[day] = sourceSlots;
        return acc;
      }, {});

    }
    const body = {
      doctor_id: doctorId,
      type: activeTab,
      sync: data?.to_all_time,
      availability: finalSlots,
      slot_duration: watchTime("slot_duration")?.value,
      fee: watchTime("online_consultation_fees"),
    };
    const slo = transformBack(body);
    const finalBody = {
      doctorId: doctorId,
      slot_duration: watchTime("slot_duration")?.value,
      fee: watchTime("online_consultation_fees"),
      availability: slo?.availability,
    };
    console.log("finla", finalBody);

    doctorOnlineSlot(finalBody)
      .then((res) => {
        if (res.data.status === true) {
          toast.success(res.data.message);
          toast.clearWaitingQueue();
          navigate("/doctors", {
            state: { mode: "Add", doctorId: res.data.data?.doctorId },
          });
        } else if (res.data.status === false) {
          toast.error(res.data.message);
          toast.clearWaitingQueue();
        } else if (res.data.status === "expired") {
          toast.error(res.data.message);
          toast.clearWaitingQueue();
          logout();
        }
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message);
      });
  };
  const pinCode = watchOffline("pin_code");
  const [zipLoader, setZipLoader] = useState(false);
  useEffect(() => {
    setValueOffline("mobile", doctor?.mobile || "");
    setValueOffline("city", undefined);
    setValueOffline("state", undefined);
    if (pinCode && pinCode.toString().length === 6) {
      getZipDetails({ pin_code: pinCode });
    }
  }, [pinCode, doctor?.mobile]);

  const getZipDetails = (body) => {
    setZipLoader(true);
    getZipDetailsAPI(body)
      .then((res) => {
        if (res.data.status === true) {
          const responseData = res.data.data[0];
          setValueOffline("city", responseData.district_name);
          setValueOffline("state", responseData.state_name);
          setZipLoader(false);
        } else if (res.data.status === "expired") {
          toast.error(res.data.message);
          logout();
        } else if (res.data.status === false) {
          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        setZipLoader(false);
        toast.error(err?.response?.data?.message);
      });
  };

  const to12Hour = (time) => {
    if (!time) return "";
    let [hour, minute] = time.split(":");
    hour = parseInt(hour);
    const ampm = hour >= 12 ? "PM" : "AM";
    hour = hour % 12 || 12;
    return `${hour}:${minute} ${ampm}`;
  };







  const toTime = (e, day) => {
    const sync = e.target.checked;
    setValueTime("to_all_time", sync, {
      shouldDirty: true,
      shouldValidate: true,
    });

    if (sync) {
      const sourceSlots = watchTime(`slots.${day}`) || [];
      DAYS.forEach((d) => {
        setValueTime(`slots.${d}`, sourceSlots, {
          shouldDirty: true,
          shouldValidate: true,
        });
      });
    }
  };

  const toOffline = (e) => {
    const isChecked = e.target.checked;
    setValueOffline("to_all_offline", isChecked);

    if (isChecked) {
      const activeDayClinics = watchOffline(`clinics.${activeDay}`) || [];
      DAYS.forEach((day) => {
        if (day !== activeDay) {
          setValueOffline(`clinics.${day}`, [...activeDayClinics]);
        }
      });
    }
  };

  const handleAddTimeSlot = () => {
    let newSlot = { ...defaultSlotStructureTime };
    appendTime(newSlot);
  };

  // const handleAddOfflineClinic = () => {
  //    setShowOfflineForm(true);
  //   let newClinic = { ...defaultClinicStructure };
  //   appendOfflineClinic(newClinic);
  // };
  const handleAddOfflineClinic = () => {
    if (showOfflineForm) {
      toast.warning("Please save or close the current clinic first");
      return;
    }

    setShowOfflineForm(true);
    replaceOfflineClinics([{ ...defaultClinicStructure }]);
  };

  const handleAddOfflineSlot = (clinicIndex) => {
    const { appendSlot } = handleClinicSlotOperations(clinicIndex);
    appendSlot();
  };


  const handlePinCodeChange = (clinicIndex, pinCode) => {
    getZipDetailsAPI({ pin_code: pinCode })
      .then((res) => {
        if (res.data.status === true) {
          const data = res.data.data[0];

          setValueOffline(`clinics.${activeDay}.${clinicIndex}.city`, data.district_name);
          setValueOffline(`clinics.${activeDay}.${clinicIndex}.state`, data.state_name);
        }
      })
      .catch(() => {
        setValueOffline(`clinics.${activeDay}.${clinicIndex}.city`, "");
        setValueOffline(`clinics.${activeDay}.${clinicIndex}.state`, "");
      });
  };



  useEffect(() => {
    if (activeTab === "offline") {
      const existingClinics = watchOffline(`clinics.${activeDay}`);
      if (!existingClinics || !Array.isArray(existingClinics) || existingClinics.length === 0) {
        replaceOfflineClinics([{ ...defaultClinicStructure }]);
      } else {
        replaceOfflineClinics(existingClinics);
      }
    }
  }, [activeDay, activeTab]);

  const getSlots = () => {
    const body = {
      doctor_id: doctor?.doctorId,
      type: activeTab,
    };

    setLoading(true);

    getDoctorSlotAPI(body)
      .then((res) => {
        if (res.data.status === true) {
          const apiSlots = res.data.data?.slots || {};
          const syncStatus = res.data.data?.sync || false;
          const duration = res.data.data.slot_duration;
          const fee = res.data.data.online_consultation_fees;
          setApi(apiSlots);

          resetTime({
            slots: DAYS.reduce((acc, day) => {
              const slotsForDay = (apiSlots[day] || []).map((slot) => ({
                start_time: slot.start_time || "",
                end_time: slot.end_time || "",
                id: slot.id,
              }));

              if (slotsForDay.length === 0) {
                acc[day] = [{ ...defaultSlotStructureTime }];
              } else {
                acc[day] = slotsForDay;
              }

              return acc;
            }, {}),
            to_all_time: syncStatus,
            slot_duration: duration,
            online_consultation_fees: fee,
          });

          setLoading(false);
        } else {
          setLoading(false);
          // toast.error(res.data.message);
          if (res.data.status === "expired") logout();
        }
      })
      .catch((err) => {
        setLoading(false);
        // toast.error(err?.response?.data?.message);
      });
  };

  // for set slot details in the from
  // useEffect(() => {
  //   if (activeTab === "offline") {
  //     getSlotsOffline();
  //   } else if (activeTab === "online") {
  //     getSlots();
  //   }
  // }, [activeTab]);
  const [offlineClinicCards, setOfflineClinicCards] = useState({});

  const getSlotsOffline = () => {
    setLoading(true);

    getDoctorOfflineAPI({
      doctor_id: doctor?.doctorId,
      type: "offline",
    })
      .then((res) => {
        if (!res?.data?.status) {
          // toast.error(res?.data?.message);
          setLoading(false);
          return;
        }

        const clinicsArray = res.data.data || [];

        const byDay = {};
        DAYS.forEach((day) => (byDay[day] = []));

        clinicsArray.forEach((clinic) => {
          clinic.availability?.forEach((a) => {
            if (a.slots?.length > 0) {
              byDay[a.day].push({
                clinic_id: clinic.id,
                clinic_name: clinic.clinic_name,
                clinic_address: clinic.clinic_address,
                mobile: clinic.clinic_phone,
                pin_code: clinic.pincode,
                city: clinic.city,
                state: clinic.state,
                slot_duration: clinic.slot_duration?.toString(),
                fees: clinic.fee?.toString(),
                slots: a.slots,
                day: a.day,
              });
            }
          });
        });

        setOfflineClinicCards(byDay);
        setLoading(false);
      })
      .catch(() => {
        toast.error("Failed to load clinics");
        setLoading(false);
      });
  };

  const handleDeleteClinic = (clinicId) => {
    const body = {
      clinic_id: clinicId,
    };
    if (!window.confirm("Delete this clinic?")) return;

    deleteClinicAPI(body).then(() => {
      toast.success("Clinic deleted");
      getSlotsOffline(); // refresh
    });
  };

  const [showOfflineForm, setShowOfflineForm] = useState(false);
  const [editingClinicId, setEditingClinicId] = useState(null);

  const handleEditClinic = (clinic) => {
    setMode("Edit");
    setShowOfflineForm(true);
    setEditingClinicId(clinic.clinic_id);
    setActiveDay(clinic.day);

    // Build clinics object for all days
    const clinicsByDay = DAYS.reduce((acc, day) => {
      // Find availability for this day
      const availabilityForDay = offlineClinicCards?.[day]?.find((c) => c.clinic_id === clinic.clinic_id)?.slots || [];

      acc[day] = [
        {
          clinic_id: clinic.clinic_id,
          clinic_name: clinic.clinic_name,
          clinic_address: clinic.clinic_address,
          mobile: clinic.mobile,
          pin_code: clinic.pin_code,
          city: clinic.city,
          state: clinic.state,
          slot_duration: Number(clinic.slot_duration),
          fees: Number(clinic.fees),

          slots:
            availabilityForDay.length > 0
              ? availabilityForDay.map((s) => ({
                start_time: s.start_time,
                end_time: s.end_time,
              }))
              : [{ start_time: "", end_time: "" }], // blank slot
        },
      ];

      return acc;
    }, {});

    resetOffline({
      to_all_offline: false,
      clinics: clinicsByDay,
    });
  };
  setTimeout(() => {
    document.getElementById("offline-clinic-form")?.scrollIntoView({ behavior: "smooth" });
  }, 200);
  // resetOffline({
  //   clinics: {
  //     [clinic.day]: [ {defaultSlotStructureOffline} ],
  //   },
  // });

  const offlineClinicsByDay = watchOffline("clinics") || {};
  const allClinics = useMemo(() => {
    const map = new Map();

    Object.values(offlineClinicCards || {}).forEach((dayClinics = []) => {
      dayClinics.forEach((clinic) => {
        if (!map.has(clinic.clinic_id)) {
          map.set(clinic.clinic_id, clinic);
        }
      });
    });

    return Array.from(map.values());
  }, [offlineClinicCards]);

  const handleClinicSlotOperations = (clinicIndex) => {
    const slots = watchOffline(`clinics.${activeDay}.${clinicIndex}.slots`) || [];

    const appendSlot = () => {
      setValueOffline("to_all_offline", false); // break sync

      setValueOffline(`clinics.${activeDay}.${clinicIndex}.slots`, [...slots, { start_time: "", end_time: "" }], {
        shouldDirty: true,
      });
    };

    const removeSlot = (slotIndex) => {
      setValueOffline("to_all_offline", false); // break sync

      const updatedSlots = slots.filter((_, i) => i !== slotIndex);

      setValueOffline(`clinics.${activeDay}.${clinicIndex}.slots`, updatedSlots, { shouldDirty: true });
    };

    return { slots, appendSlot, removeSlot };
  };
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const handleDeleteClick = (clinic) => {
    setSelectedRow(clinic);
    setShowDeleteModal(true);
  };

  return (
    <>
      <Head title={"Doctor registration | Slot Management"} />
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page tag="h3">
                {"Doctor Registration"}
              </BlockTitle>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>
        <Block>
          <PreviewAltCard>
            <StepHeader current={3} />
            <Row>
              <Col md={10}>
                <Nav tabs className="nav-tabs-s2">
                  <NavItem>
                    <NavLink
                      tag="a"
                      href="#tab"
                      className={classnames({ active: activeTab === "offline" })}
                      onClick={(ev) => {
                        ev.preventDefault();
                        toggle("offline");
                      }}
                    >
                      Clinic Visits
                    </NavLink>
                  </NavItem>
                  <NavLink
                    tag="a"
                    href="#tab"
                    className={classnames({ active: activeTab === "online" })}
                    onClick={(ev) => {
                      ev.preventDefault();
                      toggle("online");
                    }}
                  >
                    Video Consultations
                  </NavLink>
                </Nav>
              </Col>

              {allClinics?.length < 2 && (
                <Col md={2}>
                  {" "}
                  <div className="d-flex align-items-center  text-end">
                    {/* <span className="badge bg-primary">
                                            {offlineClinicsFields.length} Clinic(s) for {activeDay}
                                          </span> */}
                    {/* { activeTab === "offline" && (  <Button
                                type="button"
                                color="primary"
                                size="sm"
                                onClick={handleAddOfflineClinic}
                                disabled={offlineClinicsFields.length >= 5}
                                title={offlineClinicsFields.length >= 2 ? "Maximum 5 clinics allowed" : "Add New Clinic"}
                              >
                                + Add Clinic
                              </Button>)} */}
                  </div>
                </Col>
              )}
            </Row>
            <TabContent activeTab={activeTab}>
              <TabPane tabId="offline">
                <PreviewAltCard>
                  <>

                    <Form onSubmit={handleSubmitOffline(onFormSubmitOffline)}>
                      <Row>
                        <div className="d-flex justify-content-between align-items-center mb-3">
                          <h5>{"Clinics/Hospitals"}</h5>
                          {/* <div className="d-flex align-items-center gap-3">
                                          <span className="badge bg-primary">
                                            {offlineClinicsFields.length} Clinic(s) for {activeDay}
                                          </span>
                                          <Button
                                            type="button"
                                            color="primary"
                                            size="sm"
                                            onClick={handleAddOfflineClinic}
                                            disabled={offlineClinicsFields.length >= 5}
                                            title={
                                              offlineClinicsFields.length >= 5 ? "Maximum 5 clinics allowed" : "Add New Clinic"
                                            }
                                          >
                                            + Add Clinic
                                          </Button>
                                        </div> */}
                        </div>
                        <Col>
                          {/* <div className="text-end">
                                          <Button
                                           type="button"
                                            color="danger"
                                            size="sm"
                                            className="text-end rounded"
                                            style={{ cursor: "pointer", border: "none" }}
                                            onClick={() => {
                                              setShowOfflineForm(false);
                                            }}
                                          >
                                            {" "}
                                            Close Form
                                          </Button>
                                        </div> */}
                        </Col>
                        <Col md={12}>
                          <ul className="nav nav-pills mb-3 flex-wrap mx-1">
                            {DAYS.map((day) => (
                              <li className="nav-item me-2 mb-2" key={day}>
                                <button
                                  type="button"
                                  onClick={() => setActiveDay(day)}
                                  className={`btn btn-sm ${activeDay === day ? "btn-primary" : "btn-outline-primary"
                                    } text-capitalize`}
                                >
                                  {day}
                                </button>
                              </li>
                            ))}
                          </ul>
                        </Col>

                        <>
                          {" "}
                          <Col md={5}>
                            <div className="ms-2 form-control-wrap">
                              <div className="d-flex justify-content-start align-items-center">
                                <input
                                  type="checkbox"
                                  id={"to_all_offline"}
                                  {...registerOffline("to_all_offline")}
                                  className="form-check my-1"
                                  checked={watchOffline("to_all_offline")}
                                  onChange={(e) => toOffline(e)}
                                />
                                <span htmlFor={"to_all_offline"} className="mx-1 my-1">
                                  {"sync clinic"}
                                </span>
                                {watchOffline("to_all_offline") && (
                                  <span className="badge bg-warning ms-2">synced clinic</span>
                                )}
                              </div>
                            </div>
                          </Col>
                          <Col md={12}>
                            {offlineClinicsFields.length === 0 && (
                              <div className="alert alert-info">
                                <p className="mb-0">
                                  No clinics added yet. Click "Add Clinic" button to add a new clinic.
                                </p>
                              </div>
                            )}

                            {offlineClinicsFields.map((clinic, clinicIndex) => {
                              const { slots: clinicSlots, removeSlot } = handleClinicSlotOperations(clinicIndex);

                              return (
                                <div key={clinic.id} className="card mb-4 border-primary">
                                  <div className="card-header bg-primary bg-opacity-10 d-flex justify-content-between align-items-center">
                                    <h5 className="mb-0">Clinic {clinicIndex + 1}</h5>
                                    <button
                                      type="button"
                                      onClick={() => removeOfflineClinic(clinicIndex)}
                                      className="btn btn-danger btn-sm"
                                      disabled={offlineClinicsFields.length === 1}
                                    >
                                      Remove Clinic
                                    </button>
                                  </div>
                                  <div className="card-body">
                                    {/* Clinic Details */}
                                    <Row className="mb-4">
                                      <Col md={3}>
                                        <div className="form-group my-2">
                                          <label className="form-label fw-semibold">Clinic Name </label>
                                          <input
                                            type="text"
                                            placeholder="Enter clinic name"
                                            {...registerOffline(`clinics.${activeDay}.${clinicIndex}.clinic_name`, {
                                              required: "Clinic name is required",
                                              pattern: {
                                                value: /^[A-Za-z0-9_\/]+(?: [A-Za-z0-9_\/]+)*$/,
                                                message:
                                                  "Only letters, numbers, underscore (_), slash (/) and single spaces between words are allowed",
                                              },
                                            })}
                                            className="form-control"
                                          />
                                          {errorsOffline?.clinics?.[activeDay]?.[clinicIndex]?.clinic_name && (
                                            <small className="text-danger">
                                              {errorsOffline.clinics[activeDay][clinicIndex].clinic_name.message}
                                            </small>
                                          )}
                                        </div>
                                      </Col>
                                      <Col md="3">
                                        <MyMobile
                                          register={registerOffline}
                                          watch={watchOffline}
                                          setValue={setValueOffline}
                                          trigger={triggerOffline}
                                          errors={errorsOffline}
                                          title={"Mobile "}
                                          name={`clinics.${activeDay}.${clinicIndex}.mobile`}
                                          placeholder={"Enter mobile"}
                                          required
                                        />
                                      </Col>
                                      <Col md={3}>
                                        <div className="form-group my-2">
                                          <label className="form-label fw-semibold">Fees </label>
                                          <input
                                            type="text"
                                            placeholder="Enter consultation fees"
                                            {...registerOffline(`clinics.${activeDay}.${clinicIndex}.fees`, {
                                              required: "Fees is required",
                                              pattern: {
                                                value: /^[0-9]+$/,
                                                message: "Fees must be a valid number",
                                              },
                                            })}
                                            onInput={(e) => {
                                              e.target.value = e.target.value.replace(/\D/g, "");
                                            }}
                                            className="form-control"
                                          />
                                          {errorsOffline?.clinics?.[activeDay]?.[clinicIndex]?.fees && (
                                            <small className="text-danger">
                                              {errorsOffline.clinics[activeDay][clinicIndex].fees.message}
                                            </small>
                                          )}
                                        </div>
                                      </Col>

                                      {/* <Col md="2">
                                                      <MySelect
                                                        register={registerOffline}
                                                        watch={watchOffline}
                                                        setValue={setValueOffline}
                                                        trigger={triggerOffline}
                                                        errors={errorsOffline}
                                                        title={"Slot Duration "}
                                                        name={`clinics.${activeDay}.${clinicIndex}.slot_duration`}
                                                        placeholder={"Select slot duration"}
                                                        required
                                                        options={slotDuration}
                                                      />
                                                    </Col> */}
                                      <Col md="3">
                                        <div className="form-group">
                                          <label className="form-label fw-semibold">Slot Duration</label>

                                          <select
                                            className="form-control"
                                            {...registerOffline(`clinics.${activeDay}.${clinicIndex}.slot_duration`, {
                                              required: "Slot duration is required",
                                            })}
                                          >
                                            <option value="">Select duration</option>

                                            {slotDuration.map((d) => (
                                              <option key={d.value} value={d.value}>
                                                {d.label}
                                              </option>
                                            ))}
                                          </select>

                                          {errorsOffline?.clinics?.[activeDay]?.[clinicIndex]?.slot_duration && (
                                            <small className="text-danger">
                                              {errorsOffline.clinics[activeDay][clinicIndex].slot_duration.message}
                                            </small>
                                          )}
                                        </div>
                                      </Col>

                                      <Col md={3}>
                                        <div className="form-group my-2">
                                          <label className="form-label fw-semibold">Pin Code </label>
                                          <input
                                            type="text"
                                            placeholder="Enter pin code"
                                            maxLength={6}
                                            {...registerOffline(`clinics.${activeDay}.${clinicIndex}.pin_code`, {
                                              required: "Pin code is required",
                                              pattern: {
                                                value: /^[0-9]{6}$/,
                                                message: "Pin code must be exactly 6 digits",
                                              },
                                              onChange: (e) => handlePinCodeChange(clinicIndex, e.target.value),
                                            })}
                                            onInput={(e) => {
                                              e.target.value = e.target.value.replace(/\D/g, "");
                                            }}
                                            className="form-control"
                                          />
                                          {errorsOffline?.clinics?.[activeDay]?.[clinicIndex]?.pin_code && (
                                            <small className="text-danger">
                                              {errorsOffline.clinics[activeDay][clinicIndex].pin_code.message}
                                            </small>
                                          )}
                                        </div>
                                      </Col>
                                      <Col md={3}>
                                        <div className="form-group my-2">
                                          <label className="form-label fw-semibold">City</label>
                                          <input
                                            type="text"
                                            placeholder="Enter city"
                                            {...registerOffline(`clinics.${activeDay}.${clinicIndex}.city`, {})}
                                            className="form-control"
                                            readOnly
                                          />
                                        </div>
                                      </Col>
                                      <Col md={3}>
                                        <div className="form-group my-2">
                                          <label className="form-label fw-semibold">State</label>
                                          <input
                                            type="text"
                                            placeholder="Enter state"
                                            {...registerOffline(`clinics.${activeDay}.${clinicIndex}.state`, {})}
                                            readOnly
                                            className="form-control"
                                          />
                                        </div>
                                      </Col>

                                      <Col md={3}>
                                        <div className="form-group my-2">
                                          <label className="form-label fw-semibold">Full Address</label>
                                          <textarea
                                            {...registerOffline(`clinics.${activeDay}.${clinicIndex}.clinic_address`, {
                                              required: "Address is required",
                                            })}
                                            className="form-control"
                                            placeholder="Enter full clinic address"
                                            rows="3"
                                          />
                                          {errorsOffline?.clinics?.[activeDay]?.[clinicIndex]?.clinic_address && (
                                            <small className="text-danger">
                                              {errorsOffline.clinics[activeDay][clinicIndex].clinic_address.message}
                                            </small>
                                          )}
                                        </div>
                                      </Col>
                                    </Row>

                                    {/* Time Slots for this Clinic */}
                                    <div className="mt-4">
                                      <div className="d-flex justify-content-between align-items-center mb-3">
                                        <h6 className="mb-0">Time Slots for this Clinic</h6>
                                        <button
                                          type="button"
                                          onClick={() => handleAddOfflineSlot(clinicIndex)}
                                          className="btn btn-outline-primary btn-sm"
                                        // disabled={clinicSlots.length >= 2}
                                        // title={
                                        //   clinicSlots.length > 2 ? "Maximum 4 slots per clinic" : "Add Time Slot"
                                        // }
                                        >
                                          + Add Time Slot
                                        </button>
                                      </div>

                                      {clinicSlots.length === 0 && (
                                        <div className="alert alert-warning">
                                          <p className="mb-0">
                                            No time slots added for this clinic.
                                          </p>
                                        </div>
                                      )}
                                      <Row>
                                        {clinicSlots.map((slot, slotIndex) => (
                                          <Col md={3} key={slotIndex}>
                                            <div className="card mb-3 border-0 shadow-sm">
                                              <div className="card-body">
                                                <div className="d-flex justify-content-between align-items-center mb-2">
                                                  <h6 className="mb-0">Slot {slotIndex + 1}</h6>
                                                  {/* <button
                                                                  type="button"
                                                                  onClick={() => removeSlot(slotIndex)}
                                                                  className="btn btn-outline-danger btn-sm"
                                                                  // disabled={clinicSlots.length === 1}
                                                                >
                                                                  Remove
                                                                </button> */}
                                                  <button
                                                    type="button"
                                                    className="btn btn-outline-danger btn-sm"
                                                    onClick={() => removeSlot(slotIndex)}
                                                  >
                                                    Remove
                                                  </button>
                                                </div>
                                                {/* <div className="form-group my-2">
                                                                <label className="form-label">Start Time</label>
                                                                <input
                                                                  type="time"
                                                                  {...registerOffline(
                                                                    `clinics.${activeDay}.${clinicIndex}.slots.${slotIndex}.start_time`,
                                                                    {
                                                                      required: "Start time is required",
                                                                    }
                                                                  )}
                                                                  className="form-control"
                                                                />
                                                                {errorsOffline?.clinics?.[activeDay]?.[clinicIndex]?.slots?.[
                                                                  slotIndex
                                                                ]?.start_time && (
                                                                  <small className="text-danger">
                                                                    {
                                                                      errorsOffline.clinics[activeDay][clinicIndex].slots[slotIndex]
                                                                        .start_time.message
                                                                    }
                                                                  </small>
                                                                )}
                                                              </div> */}
                                                <div className="form-group my-2">
                                                  <label className="form-label">Start Time</label>
                                                  <select
                                                    {...registerOffline(
                                                      `clinics.${activeDay}.${clinicIndex}.slots.${slotIndex}.start_time`,
                                                      { required: "Start time is required" }
                                                    )}
                                                    className="form-control"
                                                  >
                                                    {Array.from({ length: 24 }).flatMap((_, hour) => {
                                                      const displayHour = hour % 12 === 0 ? 12 : hour % 12;
                                                      const ampm = hour < 12 ? "AM" : "PM";
                                                      return [0, 15, 30, 45].map((min) => {
                                                        const value = `${hour.toString().padStart(2, "0")}:${min
                                                          .toString()
                                                          .padStart(2, "0")}`;
                                                        const label = `${displayHour}:${min
                                                          .toString()
                                                          .padStart(2, "0")} ${ampm}`;
                                                        return (
                                                          <option key={`${hour}-${min}`} value={value}>
                                                            {label}
                                                          </option>
                                                        );
                                                      });
                                                    })}
                                                  </select>
                                                  {errorsOffline?.clinics?.[activeDay]?.[clinicIndex]?.slots?.[
                                                    slotIndex
                                                  ]?.start_time && (
                                                      <small className="text-danger">
                                                        {
                                                          errorsOffline.clinics[activeDay][clinicIndex].slots[slotIndex]
                                                            .start_time.message
                                                        }
                                                      </small>
                                                    )}
                                                </div>
                                                <div className="form-group my-2">
                                                  <label className="form-label">End Time</label>
                                                  <select
                                                    {...registerOffline(
                                                      `clinics.${activeDay}.${clinicIndex}.slots.${slotIndex}.end_time`,
                                                      { required: "End time is required" }
                                                    )}
                                                    className="form-control"
                                                  >
                                                    {Array.from({ length: 24 }).flatMap((_, hour) => {
                                                      const displayHour = hour % 12 === 0 ? 12 : hour % 12;
                                                      const ampm = hour < 12 ? "AM" : "PM";
                                                      return [0, 15, 30, 45].map((min) => {
                                                        const value = `${hour.toString().padStart(2, "0")}:${min
                                                          .toString()
                                                          .padStart(2, "0")}`;
                                                        const label = `${displayHour}:${min
                                                          .toString()
                                                          .padStart(2, "0")} ${ampm}`;
                                                        return (
                                                          <option key={`${hour}-${min}`} value={value}>
                                                            {label}
                                                          </option>
                                                        );
                                                      });
                                                    })}
                                                  </select>
                                                  {errorsOffline?.clinics?.[activeDay]?.[clinicIndex]?.slots?.[
                                                    slotIndex
                                                  ]?.end_time && (
                                                      <small className="text-danger">
                                                        {
                                                          errorsOffline.clinics[activeDay][clinicIndex].slots[slotIndex]
                                                            .end_time.message
                                                        }
                                                      </small>
                                                    )}
                                                </div>

                                                {/* <div className="form-group my-2">
                                                                <label className="form-label">End Time</label>
                                                                <input
                                                                  type="time"
                                                                  {...registerOffline(
                                                                    `clinics.${activeDay}.${clinicIndex}.slots.${slotIndex}.end_time`,
                                                                    {
                                                                      required: "End time is required",
                                                                    }
                                                                  )}
                                                                  className="form-control"
                                                                />
                                                                {errorsOffline?.clinics?.[activeDay]?.[clinicIndex]?.slots?.[
                                                                  slotIndex
                                                                ]?.end_time && (
                                                                  <small className="text-danger">
                                                                    {
                                                                      errorsOffline.clinics[activeDay][clinicIndex].slots[slotIndex]
                                                                        .end_time.message
                                                                    }
                                                                  </small>
                                                                )}
                                                              </div> */}
                                              </div>
                                            </div>
                                          </Col>
                                        ))}
                                      </Row>
                                    </div>
                                  </div>
                                </div>
                              );
                            })}

                            <div className="d-flex justify-content-between mt-4">
                              {/* <div>
                                        {offlineClinicsFields.length < 5 && (
                                          <Button className="btn btn-primary" type="button" onClick={handleAddOfflineClinic}>
                                            + Add New Clinic
                                          </Button>
                                        )}
                                      </div> */}
                              <Col md="2" className="">
                                <MyButton mode={mode} />
                              </Col>
                            </div>
                          </Col>
                        </>
                      </Row>
                    </Form>
                    {/* )} */}
                  </>
                </PreviewAltCard>
              </TabPane>

              {/* ========== ONLINE TAB (Video Consultations) ========== */}
              <TabPane tabId="online">
                <PreviewAltCard>
                  <Form onSubmit={handleSubmitTime(onFormSubmitTime)}>
                    <Row>
                      <div className="d-flex gap-5 mb-3">
                        <h5>{"Video Consultation Slots"}</h5>
                      </div>

                      <Col md={12}>
                        <ul className="nav nav-pills mb-3 flex-wrap mx-1">
                          {DAYS.map((day) => (
                            <li className="nav-item me-2 mb-2" key={day}>
                              <button
                                type="button"
                                onClick={() => setActiveDay(day)}
                                className={`btn btn-sm ${activeDay === day ? "btn-primary" : "btn-outline-primary"
                                  } text-capitalize`}
                              >
                                {day}
                              </button>
                            </li>
                          ))}
                        </ul>
                      </Col>
                      <Row md={2}>
                        <div className="row ms-2 form-control-wrap ">
                          <div className="d-flex justify-content-start">
                            <input
                              type="checkbox"
                              id={"to_all_time"}
                              {...registerTime("to_all_time", {})}
                              className="form-check "
                              checked={watchTime("to_all_time")}
                              onChange={(e) => toTime(e, `${activeDay}`)}
                            />
                            <span htmlFor={"to_all_time"} className="mx-1 my-1">
                              {"sync all days"}
                            </span>
                          </div>
                        </div>
                      </Row>
                      <Col>
                        <div key={activeDay}>
                          {/* {timeFields.length === 0 && (
                                        <p className="text-muted small">
                                          No time slots added yet for <b>{activeDay}</b>. Click below to add one.
                                        </p>
                                      )} */}

                          <Row>
                            {timeFields.map((field, index) => (
                              <Col md="3" key={field.id}>
                                <div className="card mb-3 border-0 shadow-sm">
                                  <div className="card-body">
                                    <div className="d-flex justify-content-between align-items-center mb-3">
                                      <h5 className="mb-0">Session {index + 1}</h5>

                                      <button
                                        type="button"
                                        className="btn btn-outline-danger btn-sm"
                                        onClick={() => {
                                          // Break sync when removing a slot
                                          const isSynced = watchTime("to_all_time");

                                          if (isSynced) {
                                            // Disable sync when removing a slot
                                            setValueTime("to_all_time", false, { shouldDirty: true });

                                            // Update all days to remove this slot
                                            DAYS.forEach((day) => {
                                              const daySlots = watchTime(`slots.${day}`) || [];
                                              if (daySlots.length > index) {
                                                const updatedSlots = [...daySlots];
                                                updatedSlots.splice(index, 1);

                                                // If no slots left for this day, add an empty slot
                                                if (updatedSlots.length === 0) {
                                                  updatedSlots.push({ ...defaultSlotStructureTime });
                                                }

                                                setValueTime(`slots.${day}`, updatedSlots, {
                                                  shouldDirty: true,
                                                  shouldValidate: true,
                                                });
                                              }
                                            });
                                          } else {
                                            // Just remove from current day
                                            const currentDaySlots = watchTime(`slots.${activeDay}`) || [];
                                            if (currentDaySlots.length > 1) {
                                              removeTime(index);
                                            } else {
                                              // Don't remove if it's the only slot, just clear it
                                              setValueTime(`slots.${activeDay}.${index}.start_time`, "", {
                                                shouldDirty: true,
                                                shouldValidate: true,
                                              });
                                              setValueTime(`slots.${activeDay}.${index}.end_time`, "", {
                                                shouldDirty: true,
                                                shouldValidate: true,
                                              });
                                            }
                                          }
                                        }}
                                      >
                                        Remove
                                      </button>
                                    </div>

                                    <Row>
                                      <Col md={12}>
                                        {/* <div className="time-card"> */}
                                          {/* Start Time */}
                                          <div className="form-group my-2">
                                            <label className="form-label">Start Time</label>
                                            <select
                                              {...registerTime(`slots.${activeDay}.${index}.start_time`, {
                                                required: "Start time is required",
                                              })}
                                              value={watchTime(`slots.${activeDay}.${index}.start_time`) || ""}
                                              onChange={(e) => {
                                                const value = e.target.value;
                                                setValueTime(`slots.${activeDay}.${index}.start_time`, value, {
                                                  shouldDirty: true,
                                                  shouldValidate: true,
                                                });

                                                const isSynced = watchTime("to_all_time");
                                                if (isSynced) {
                                                  DAYS.forEach((day) => {
                                                    setValueTime(`slots.${day}.${index}.start_time`, value, {
                                                      shouldDirty: true,
                                                      shouldValidate: true,
                                                    });
                                                  });
                                                }
                                              }}
                                              className="time-select form-control"
                                            >
                                              <option value="">Select start time</option>
                                              {Array.from({ length: 24 }).flatMap((_, hour) => {
                                                const displayHour = hour % 12 === 0 ? 12 : hour % 12;
                                                const ampm = hour < 12 ? "AM" : "PM";
                                                return [0, 15, 30, 45].map((min) => {
                                                  const value = `${hour.toString().padStart(2, "0")}:${min
                                                    .toString()
                                                    .padStart(2, "0")}`;
                                                  const label = `${displayHour}:${min
                                                    .toString()
                                                    .padStart(2, "0")} ${ampm}`;
                                                  return (
                                                    <option key={`${hour}-${min}`} value={value}>
                                                      {label}
                                                    </option>
                                                  );
                                                });
                                              })}
                                            </select>
                                          </div>

                                          {/* End Time */}
                                          <div className="form-group my-2">
                                            <label className="form-label">End Time</label>
                                            <select
                                              {...registerTime(`slots.${activeDay}.${index}.end_time`, {
                                                required: "End time is required",
                                              })}
                                              value={watchTime(`slots.${activeDay}.${index}.end_time`) || ""}
                                              onChange={(e) => {
                                                const value = e.target.value;
                                                setValueTime(`slots.${activeDay}.${index}.end_time`, value, {
                                                  shouldDirty: true,
                                                  shouldValidate: true,
                                                });

                                                const isSynced = watchTime("to_all_time");
                                                if (isSynced) {
                                                  DAYS.forEach((day) => {
                                                    setValueTime(`slots.${day}.${index}.end_time`, value, {
                                                      shouldDirty: true,
                                                      shouldValidate: true,
                                                    });
                                                  });
                                                }
                                              }}
                                              className="time-select  form-control"
                                            >
                                              <option value="">Select end time</option>
                                              {Array.from({ length: 24 }).flatMap((_, hour) => {
                                                const displayHour = hour % 12 === 0 ? 12 : hour % 12;
                                                const ampm = hour < 12 ? "AM" : "PM";
                                                return [0, 15, 30, 45].map((min) => {
                                                  const value = `${hour.toString().padStart(2, "0")}:${min
                                                    .toString()
                                                    .padStart(2, "0")}`;
                                                  const label = `${displayHour}:${min
                                                    .toString()
                                                    .padStart(2, "0")} ${ampm}`;
                                                  return (
                                                    <option key={`${hour}-${min}`} value={value}>
                                                      {label}
                                                    </option>
                                                  );
                                                });
                                              })}
                                            </select>
                                          </div>
                                        {/* </div> */}
                                      </Col>
                                    </Row>
                                  </div>
                                </div>
                              </Col>
                            ))}
                          </Row>
                          <Row>
                            <Col md="3">
                              <MyInput
                                register={registerTime}
                                watch={watchTime}
                                setValue={setValueTime}
                                trigger={triggerTime}
                                errors={errorsTime}
                                title="Online consultation fees"
                                name="online_consultation_fees"
                                placeholder="Enter consultation fee"
                                required
                              />
                            </Col>
                            <Col md="3">
                              <MySelect
                                register={registerTime}
                                watch={watchTime}
                                setValue={setValueTime}
                                trigger={triggerTime}
                                errors={errorsTime}
                                title={"Slot Duration"}
                                name={"slot_duration"}
                                placeholder={"duration"}
                                required
                                options={slotDuration}
                              />
                            </Col>
                          </Row>
                          <div className="d-flex justify-content-between mt-3">
                            <Button className="btn btn-primary" type="button" onClick={handleAddTimeSlot}>
                              + Add Time Slot
                            </Button>

                            <button type="submit" className="btn btn-primary">
                              Save Video Consultation Slots
                            </button>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </Form>
                </PreviewAltCard>
              </TabPane>
            </TabContent>
          </PreviewAltCard>
        </Block>
      </Content>
    </>
  );
};

export default StepThree;
